import { render, staticRenderFns } from "./albertprod.vue?vue&type=template&id=6a5285c8&"
import script from "./albertprod.vue?vue&type=script&lang=js&"
export * from "./albertprod.vue?vue&type=script&lang=js&"
import style0 from "./albertprod.vue?vue&type=style&index=0&id=6a5285c8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5285c8')) {
      api.createRecord('6a5285c8', component.options)
    } else {
      api.reload('6a5285c8', component.options)
    }
    module.hot.accept("./albertprod.vue?vue&type=template&id=6a5285c8&", function () {
      api.rerender('6a5285c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertprod.vue"
export default component.exports